module.exports = __webpack_public_path__ + "static/logo-vitalite2020-a940fb602374370080a36baa81db582f.png";